// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import type { StepComponentProps } from '../../types/wizard';
import { FileUploadField } from '../shared/FileUploadField';

export function StepTransactionHistory({
  pendingFiles,
  onAddFile,
  onRemoveFile,
}: StepComponentProps) {
  return (
    <div className="flex flex-col gap-lg">
      {/* Title */}
      <div className="text-black font-sans text-h5 font-normal leading-normal not-italic">
        Transaction History
      </div>

      {/* Transaction History Upload */}
      <FileUploadField
        fieldKey="transactionHistoryUpload"
        label="Please attach full transaction history of the account since inception"
        files={pendingFiles?.get('transactionHistoryUpload')}
        onAddFile={onAddFile}
        onRemoveFile={onRemoveFile}
      />

      {/* ══════════════ Divider ══════════════ */}
      <div className="w-full h-[1px] bg-[#E1E1E1]" />

      {/* Current Valuation Upload */}
      <FileUploadField
        fieldKey="currentValuationUpload"
        label="Please attached a current valuation of the account"
        files={pendingFiles?.get('currentValuationUpload')}
        onAddFile={onAddFile}
        onRemoveFile={onRemoveFile}
      />

      {/* ══════════════ Divider ══════════════ */}
      <div className="w-full h-[1px] bg-[#E1E1E1]" />

      {/* SORP Upload */}
      <FileUploadField
        fieldKey="sorpUpload"
        label="Please attached a Statement of Reasonable Projection (SORP)"
        files={pendingFiles?.get('sorpUpload')}
        onAddFile={onAddFile}
        onRemoveFile={onRemoveFile}
      />
    </div>
  );
}
